<template>
    <div :hidden="!hasMoaData" v-if="modalReady">
        <div class="modal fade" id="moa-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-fixed" role="document">
               <div class="modal-content">
                    <div class="modal-header text-center">
                        <h5 class="modal-title mr-1" v-html="modalTitle"></h5>

                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true"><img src="img/ui-elements/close-img.png" alt="Close" /></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p v-if="modalContent.field_moa_class && modalContent.field_moa_class.length > 0">
                            <strong>Class</strong><br>
                            <span v-html="modalContent.field_moa_class[0].value"></span>
                        </p>

                        <span v-if="modalContent.field_moa_text && modalContent.field_moa_text.length > 0" v-html="modalContent.field_moa_text[0].value"></span>
                        <br/>
                        <img v-if="modalContent.field_moa_image && modalContent.field_moa_image.length > 0" :src="modalContent.field_moa_image[0].url" :alt="modalContent.field_moa_image[0].alt" />

                        <footer class="footer-references" v-if="modalContent.field_moa_reference && modalContent.field_moa_reference.length > 0">
                            <p v-html="modalContent.field_moa_reference[0].value"></p>
                        </footer>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MoaModal",
        props: ['product'],
        computed: {
            productSet: function () {
                return this.productInfo !== false;
            },
            hasMoaData: function () {
                if (!this.productInfo) return false;
                const hasClass = this.productInfo.field_moa_class && this.productInfo.field_moa_class.length > 0;
                const hasText = this.productInfo.field_moa_text && this.productInfo.field_moa_text.length > 0;
                const hasImage = this.productInfo.field_moa_image && this.productInfo.field_moa_image.length > 0;
                return hasClass || hasText || hasImage;
            },
            modalContent: function () {
                return this.productInfo;
            },
            productProp: function () {
                return this.product;
            },
            productTriangle: function() {
                let products = this.$store.getters.getProductNames;
                let filtered = products.filter(el => el.title[0].value.toLowerCase() === this.product.toLowerCase());
                let triangle = '';

                if (filtered.length > 0 && filtered[0].field_black_triangle_for_product.length > 0) {
                    triangle = filtered[0].field_black_triangle_for_product[0].value;
                }

                return triangle;
            },
            modalTitle: function() {
                return `${this.modalContent.title[0].value}${this.productTriangle}`;
            },
        },
        created: function() {

        },
        updated: function() {

        },
        watch: {
            modalContent: function () {
                if(this.modalContent !== false) {
                    this.modalReady = true;
                }
            },
            product: function() {
                if (this.product !== false) {
                    this.getModalData()
                    this.modalReady = true;
                } else {
                    this.modalReady = false;
                    this.productInfo = false;
                }
            }
        },
        mounted: function () {

            this.getModalData();
        },
        data: function () {
            return {
                productInfo: false,
                modalReady: false,
            }
        },
        methods: {
            getProductData: function () {
                let products = this.$store.getters.getProductNames;
                let filtered = products.filter(el => el.title[0].value.toLowerCase() === this.product.toLowerCase() );
                return filtered[0];
            },
            getModalData: function () {

                if(this.product === false || this.product == '')
                {
                    if(this.$route.params.filtertype == 'product') {
                        this.product = this.$route.params.filtervalue;
                    }
                }

                if(this.product !== false && this.product !== '') {
                    this.productInfo = this.getProductData();
                    console.log(this.productInfo);
                }

            }
        }
    }
</script>

<style scoped>
    .button-span {
        padding: 0 8px;
    }

    .footer-references {
        color: inherit;
        bottom: unset;
    }
</style>

<style>
    #moa-modal {
        animation: none;
    }

    #moa-modal .modal-dialog {
        margin-top: 4rem;
    }

    #moa-modal .modal-dialog.modal-fixed,
    #moa-modal .modal-dialog.modal-fixed .modal-content {
        height: 86vh;
        max-height: 86vh;
        max-width: 73vw;
        min-width: 73vw;
    }

    #moa-modal .modal-dialog.modal-fixed .modal-content {
        display: flex;
        flex-direction: column;
    }

    #moa-modal .modal-dialog.modal-fixed .modal-body {
        flex: 1 1 auto;
        max-height: none;
        overflow-y: auto;
    }
</style>